module.exports = __webpack_public_path__ + "static/contact2-ecbb612c27a68cbff144f6c2d21efe36.jpg";